import {
  post_request,
  get_request_export
} from '../axiosFun'

//查询验收日志列表
export const get_acceptanceLog_list = (params) => {
  params = {
    row: {
      vin: params.vin,
      delivery_person: params.delivery_person,
      receive_person: params.receive_person,
      acceptance_date: params.acceptance_date,
      page_no: params.page,
      page_size: params.limit
    }
  }
  return post_request("/web/acceptance/list", params)
}
// 添加验收日志
export const get_acceptanceLog_add = (params, form) => {
  params = {
    row: {
      content: params,
      vin: form.vin,
      delivery_man: form["交付联系人"],
      delivery_man_phone: form["交付方联系方式"],
      receive_man: form["接收联系人"],
      receive_man_phone: form["接收方联系方式"],
      acceptance_date: form.AccepDate
    }
  }
  return post_request("/web/acceptance/add2", params)
}
// 获取单条验收日志
export const get_acceptanceLog_one = (params) => {
  params = {
    row: {
      id: params
    }
  }
  return post_request("/web/acceptance/queryById", params)
}
// 编辑验收日志
export const get_acceptanceLog_edit = (params, form1) => {
  params = {
    row: {
      id: form1.id,
      content: params,
      vin: form1.vin,
      delivery_person: form1["交付联系人"],
      delivery_person_phone: form1["交付方联系方式"],
      receive_person: form1["接收联系人"],
      receive_person_phone: form1["接收方联系方式"],
      acceptance_date: form1.AccepDate
    }
  }
  return post_request("/web/acceptance/update", params)
}
// 删除验收日志
export const get_acceptanceLog_del = (params) => {
  params = {
    row: {
      id: params
    }
  }
  return post_request("/web/acceptance/delete", params)
}
// 修改验收状态
export const get_acceptanceLog_editStatus = (params, status) => {
  params = {
    row: {
      id: params,
      status: status
    }
  }
  return post_request("/web/acceptance/update_status", params)
}
//查询车辆列表
export const get_vin_list = (params) => {
  params = {
    row: {

    }
  }
  return post_request("/web/projectAccidentLog/get_vins", params)
}
//导出保养日志
export const get_export_acceptanceLog = (params) => {
  params = {
    row: {
      ids: params
    }
  }
  return get_request_export("/web/acceptance/export_excel", params)
}



// WEBPACK FOOTER //
// ./src/api/projectLog/acceptanceLog.js